// @flow
import { Fragment } from 'react';
import Carousel from '../ImageAndText';

import LinkPopup from '@components/popups/Link';

import * as CrownContent from '../../popups/content/Crown';
import * as TableContent from '../../popups/content/Table';
import * as GirdleContent from '../../popups/content/Girdle';
import * as PavilionContent from '../../popups/content/Pavilion';
import * as CuletContent from '../../popups/content/Culet';

const bezelFacets = '/images/anatomy_carousel/bezel_facets.gif';
const crown = '/images/anatomy_carousel/crown.gif';
const culet = '/images/anatomy_carousel/culet.gif';
const girdle = '/images/anatomy_carousel/girdle.gif';
const lowerGirdleFacets = '/images/anatomy_carousel/lower_girdle_facets.gif';
const pavilionFacets = '/images/anatomy_carousel/pavilion_facets.gif';
const pavilion = '/images/anatomy_carousel/pavilion.gif';
const starFacets = '/images/anatomy_carousel/star_facets.gif';
const table = '/images/anatomy_carousel/table.gif';
const upperGirdleFacets = '/images/anatomy_carousel/upper_girdle_facets.gif';

const items = [
  {
    headerText: 'Crown',
    component: (
      <Fragment key="Crown">
        Entire portion of the diamond that sits above the girdle. (
        <LinkPopup initialContent={CrownContent}>learn more</LinkPopup>)
      </Fragment>
    ),
    imageUrl: crown,
    imageLocation: 'top',
    imageAlt: '',
    imageStyles: {
      marginTop: 20
    }
  },
  {
    headerText: 'Table',
    component: (
      <Fragment key="Table">
        Single, flat, uppermost surface of a diamond. (
        <LinkPopup initialContent={TableContent}>learn more</LinkPopup>)
      </Fragment>
    ),
    imageUrl: table,
    imageLocation: 'top',
    imageAlt: '',
    imageStyles: {
      marginTop: 20
    }
  },
  {
    headerText: 'Star Facets',
    component: (
      <Fragment key="Star Facets">
        Facets that sit directly adjacent to the table facet.
      </Fragment>
    ),
    imageUrl: starFacets,
    imageLocation: 'top',
    imageAlt: '',
    imageStyles: {
      marginTop: 20
    }
  },
  {
    headerText: 'Bezel Facets',
    component: (
      <Fragment key="Bezel Facets">
        Kite shaped facets that sit between the table and girdle.
      </Fragment>
    ),
    imageUrl: bezelFacets,
    imageLocation: 'top',
    imageAlt: '',
    imageStyles: {
      marginTop: 20
    }
  },
  {
    headerText: 'Upper Girdle Facets',
    component: (
      <Fragment key="Upper Girdle">
        Lowest facets on the crown, sitting just above the girdle.
      </Fragment>
    ),
    imageUrl: upperGirdleFacets,
    imageLocation: 'top',
    imageAlt: '',
    imageStyles: {
      marginTop: 20
    }
  },
  {
    headerText: 'Girdle',
    component: (
      <Fragment key="Girdle">
        Outer edge of the diamond, where prongs grip. (
        <LinkPopup initialContent={GirdleContent}>learn more</LinkPopup>)
      </Fragment>
    ),
    imageUrl: girdle,
    imageLocation: 'top',
    imageAlt: '',
    imageStyles: {
      marginTop: 20
    }
  },
  {
    headerText: 'Pavilion',
    component: (
      <Fragment key="Pavilion">
        Entire portion of the diamond that sits below the girdle. (
        <LinkPopup initialContent={PavilionContent}>learn more</LinkPopup>)
      </Fragment>
    ),
    imageUrl: pavilion,
    imageLocation: 'top',
    imageAlt: '',
    imageStyles: {
      marginTop: 20
    }
  },
  {
    headerText: 'Lower Girdle Facets',
    component: (
      <Fragment key="Lower Girdle">
        Highest facets on the pavilion, sitting just below the girdle.
      </Fragment>
    ),
    imageUrl: lowerGirdleFacets,
    imageLocation: 'top',
    imageAlt: '',
    imageStyles: {
      marginTop: 20
    }
  },
  {
    headerText: 'Pavilion Facets',
    component: (
      <Fragment key="Pavilion Facets">
        Lowest facets on the pavilion, sitting adjacent to the culet.
      </Fragment>
    ),
    imageUrl: pavilionFacets,
    imageLocation: 'top',
    imageAlt: '',
    imageStyles: {
      marginTop: 20
    }
  },
  {
    headerText: 'Culet',
    component: (
      <Fragment key="Culet">
        A point, or else a very small facet at bottom of pavilion. (
        <LinkPopup initialContent={CuletContent}>learn more</LinkPopup>)
      </Fragment>
    ),
    imageUrl: culet,
    imageLocation: 'top',
    imageAlt: '',
    imageStyles: {
      marginTop: 20
    }
  }
];

const Anatomy = (props: Object) => {
  return (
    <Carousel {...props} items={items} contentStyles={{ minHeight: 310 }} />
  );
};

export default Anatomy;
